<template>
  <div class="main">
    <el-row class="button" style="height: 40px;border-bottom: 1px solid rgba(41, 155, 255, .2);">
      <el-button icon="el-icon-circle-plus-outline"
                 size="small" @touchstart="openDialog('one')" @click="openDialog('one')">
        新增策略
      </el-button>
    </el-row>
    <div class="linkage-list">
      <ul class="ul list" v-if="linkageList.length > 0">
        <li v-for="item of linkageList" :key="item.id">
          <linkage-list-item @setEditDta="setEditDta" @openDialog="openDialog" @receiveMode="receiveMode" :item="item"
                             @getLinkageList="getLinkageList"/>
        </li>
      </ul>
      <no-tactics @add="openDialog('one')" :name="'联动'" style="text-align: center;margin-top: 10%"
                  v-else></no-tactics>
    </div>

    <dialog-component
      :dialog-title="dialogTitle"
      :closeClick="false"
      :dialogVisible.sync="dialogVisible"
      :width="width"
      @dialogClose="(data) => this.dialogVisible = data">
      <div slot="content" style="min-height: 360px;">
        <strategy-mode-select v-if="operate === 'one'"
                              :mode="mode"
                              @receiveMode="receiveMode">
        </strategy-mode-select>
        <complex-strategy-form v-if="operate === 'two'" ref="complex"
                               :editData="editDta"
                               :spaceTree="spaceTree"
                               :typeList="typeList"
                               :processList="processList">
        </complex-strategy-form>
        <linkage-log-list :item="editDta" v-if="operate === 'logs'"></linkage-log-list>
        <action-logs ref="actionLogs" :item="editDta"
                     v-if="operate === 'actionLogs'"></action-logs>
      </div>
      <div class="dialog-footer" slot="footer" style="text-align: center;margin-bottom: 30px;">
        <el-button @touchstart="openDialogAndClear('two')" @click="openDialogAndClear('two')" type="primary"
                   size="mini" v-if="operate === 'one'">下一步
        </el-button>
        <el-button @touchstart="saveStrategy" @click="saveStrategy" type="primary" size="mini" v-else-if="operate === 'two'">保存</el-button>
      </div>
    </dialog-component>
  </div>
</template>

<script>
import LinkageListItem from "@/views/basic_operations/strategy/linkage/LinkageListItem";
import {getLinkageList, modifyDeviceLinkage, saveDeviceLinkage} from '@/network/device-linkage';
import NoTactics from "@/components/NoTactics";
import DialogComponent from "@/components/DialogComponent";
import ActionLogs from "@/views/basic_operations/strategy/linkage/complex/ActionLogs";
import StrategyModeSelect from "@/views/basic_operations/strategy/linkage/StrategyModeSelect";
import ComplexStrategyForm from "@/views/basic_operations/strategy/linkage/ComplexStrategyForm";
import {getSpaceTreeData} from "@/network/space-info";
import {getDeviceCategoryList} from "@/network/device-category";
import {actList} from "@/network/activiti";
import {actDeModelList} from "@/network/act-de-model";
import _ from "lodash";
import LinkageLogList from "@/views/basic_operations/strategy/linkage/complex/LinkageLogList";

export default {
  name: "LinkageList",
  components: {
    LinkageLogList,
    LinkageListItem,
    NoTactics,
    DialogComponent,
    StrategyModeSelect,
    ComplexStrategyForm, ActionLogs
  },
  data() {
    return {
      linkageList: [],
      dialogVisible: false,
      operate: '',
      mode: 'simple',
      spaceTree: {},
      typeList: [],
      processList: [],
      editDta: null,
      width: '45vw',
      dialogTitle: '添加策略',
      // 是否是复杂策略
      isComplex: false,
    }
  },
  mounted() {
    this.getLinkageList();
    this.getSpaceTreeData();
    this.getDeviceCategoryList();
    this.getActList();
  },
  methods: {
    //获取级联空间
    getSpaceTreeData() {
      getSpaceTreeData().then(res => {
        if (res.code === 0) {
          this.spaceTree = res.data
        }
      });
    },
    // 设备类型列表
    getDeviceCategoryList() {
      getDeviceCategoryList().then(res => {
        if (res.code === 0) {
          this.typeList = res.data;
        }
      });
    },
    // 流程列表
    getActList() {
      var filterList1 = []
      var filterList2 = []
      actList().then(res => {
        if (res.code === 0) {
          filterList1 = res.data
        }
        actDeModelList().then(resp => {
          if (resp.code === 0) {
            filterList2 = resp.data
          }
          // 取交集
          for (var i = 0, len = filterList2.length; i < len; i++) {
            for (var j = 0, length = filterList1.length; j < length; j++) {
              if (filterList2[i].deploy && filterList2[i].name === filterList1[j].name) {
                this.processList.push(filterList1[j])
              }
            }
          }
        });
      });
    },
    openDialogAndClear(operate) {
      this.setEditDta(null);
      this.openDialog(operate);
    },
    // 打开弹窗
    openDialog(operate) {
      this.width = '45vw';
      this.dialogTitle = '添加策略';
      if (operate === 'one') {
        this.operate = operate
        this.dialogVisible = true
      } else if (operate === 'logs') {
        this.dialogTitle = '联动记录';
        this.operate = operate
        this.dialogVisible = true
      } else if (operate === 'actionLogs') {
        this.dialogTitle = '联动记录';
        // 简单策略直接到动作列表
        this.operate = operate
        this.dialogVisible = true
      } else {
        if (this.mode === 'simple') {
          this.$router.push('/strategy/linkage/device/edit-linkage')
          this.dialogVisible = false
        } else {
          this.dialogVisible = true
          this.operate = operate
        }
      }
    },
    // 设置改变或查看的值
    setEditDta(data) {
      this.editDta = _.cloneDeep(data);
      if (!data) {
        this.isComplex = false;
        return
      }
      this.isComplex = data.type === 1;
    },
    receiveMode(mode) {
      this.mode = mode;
    },
    // 获取联动列表
    getLinkageList() {
      getLinkageList().then(res => {
        this.linkageList = res.data;
      });
    },
    saveStrategy() {
      let linkage = {};
      let deviceLinkageActiviti = {};
      // 数据校验
      if (!this.$refs.complex.name) {
        this.$message.error("请输入策略名称");
        return;
      }
      if (this.$refs.complex.condition === '1') {
        // 触发条件为设备
        if (this.$refs.complex.spaceId.length <= 0) {
          this.$message.error("选择空间");
          return false;
        }
        if (!this.$refs.complex.deviceId) {
          this.$message.error("选择设备");
          return false;
        }
        if (!this.$refs.complex.pointId) {
          this.$message.error("选择测点");
          return false;
        }
        deviceLinkageActiviti = {
          id: this.$refs.complex.activitiId,
          spaceId: this.$refs.complex.spaceId[this.$refs.complex.spaceId.length - 1],
          deviceId: this.$refs.complex.deviceId,
          pointId: this.$refs.complex.pointId,
          spaceName: this.$refs.complex.spaceName,
          deviceName: this.$refs.complex.deviceName,
          pointName: this.$refs.complex.pointName,
          procId: null,
          procName: null,
          procKey: null,
          procVersion: null,
          mode: '0',
        };
      } else if (this.$refs.complex.condition === '2') {
        // 触发条件为设备类型
        if (!this.$refs.complex.typeId) {
          this.$message.error("选择设备类型");
          return;
        }
        deviceLinkageActiviti = {
          id: this.$refs.complex.activitiId,
          deviceTypeId: this.$refs.complex.typeId,
          deviceTypeName: this.$refs.complex.typeName,
          procId: null,
          procName: null,
          procVersion: null,
          procKey: null,
          mode: '0',
        };
      }
      if (!this.$refs.complex.processId) {
        this.$message.error("选择流程");
        return;
      }
      linkage = {
        id: this.$refs.complex.id,
        name: this.$refs.complex.name,
        sceneName: this.$refs.complex.name,
        deviceLinkageActiviti: deviceLinkageActiviti,
        type: 1,
        isEnable: this.$refs.complex.isEnable,
      };
      linkage.deviceLinkageActiviti.procId = this.$refs.complex.processId;
      linkage.deviceLinkageActiviti.procName = this.$refs.complex.processName;
      linkage.deviceLinkageActiviti.procVersion = this.$refs.complex.version;
      linkage.deviceLinkageActiviti.procKey = this.$refs.complex.processKey;
      linkage.deviceLinkageActiviti.mode = this.$refs.complex.mode;

      if (this.$refs.complex.id) {
        // 编辑 modifyDeviceLinkage
        modifyDeviceLinkage(linkage).then(res => {
          if (res.code === 0) {
            this.form = {};
            this.$message.success('操作成功');
            this.dialogVisible = false
            this.getLinkageList();
            this.setEditDta(null)
          } else {
            this.$message.error(res.message);
          }
        });
        return;
      }
      saveDeviceLinkage(linkage).then(res => {
        if (res.code === 0) {
          this.form = {};
          this.$message.success('操作成功');
          this.getLinkageList();
          this.setEditDta(null)
          this.dialogVisible = false
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
}
</script>

<style scoped>
.main {
  padding: 15px 10px;
  overflow: auto;
}

/*分割线*/
.cross-line {
  width: 100%;
  margin-top: 10px;
  height: 0;
  /*border: 1px solid #299BFF;*/
  border-bottom: 1px solid rgba(41, 155, 255, 0.2);
  opacity: 0.5;
}

/*列表内容*/
.linkage-list {
  /*margin-top: 25px;*/
}

.linkage-list ul {
  padding: 0;
  list-style: none;
}

.linkage-list li {
  margin: 10px;
  float: left;
  list-style: none;
}

</style>
